import { forwardRef } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

export const MenuLabel = forwardRef<
  HTMLDivElement,
  DropdownMenu.DropdownMenuLabelProps
>(function MenuLabel({ className, ...props }, ref) {
  return (
    <DropdownMenu.Label
      ref={ref}
      className={cn(css.menuLabel, className)}
      {...props}
    />
  );
});
